export const calculateRefrigerant = (tempRow) => {
    const { qty: q, price: p, } = tempRow;
    const qty = q ?? 0;
    const price = p ?? 0;
    const preTotal = parseFloat(qty) * parseFloat(price);
    return preTotal;
};

